import { render } from "./Duvidas.vue?vue&type=template&id=0619b611"
import script from "./Duvidas.vue?vue&type=script&lang=js"
export * from "./Duvidas.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__